import React, { useState, useEffect } from "react";
import { Card, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { FiPlus, FiSearch } from "react-icons/fi";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import {
  API_CONTACT_GROUP_CREATE,
  API_CONTACT_GROUP_LIST,
  API_CONTACT_GROUP_DELETE,
} from "../../../service/url";
import { FiTrash2 } from "react-icons/fi";
import { useAuth, errorCheck } from "../auth/auth-utils";
import { toast } from 'react-toastify';
import exportData from "../../../utilities/export";
import Loader  from '../../../components/partials/components/loader';
import { getUser } from "../../../utilities/setting";
import { USER_ROLES, MODULE_ACL } from '../../../utilities/constant';

const ContactGroupList = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [searchValue, setSearchValue] = useState("");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [newGroup, setNewGroup] = useState({
    name: "",
  });
  const [loggedInUserACL, setLoggedInUserACL] = useState({})
  const [isSuperAdmin, setIsSuperadmin] = useState(false)

  const [groupsData, setGroupsData] = useState([]);

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);
  

  useEffect(() => {
    checkAuth(setToastProps, setShowToast);
  }, []);

  useEffect(() => {
    setLoading(true);
    getApiCall(API_CONTACT_GROUP_LIST, {}).then(onListSuccess).catch(onError).finally(() => setLoading(false));
      getUser().then((user) => {
        if (user.role === USER_ROLES.SUPERADMIN) {
          setIsSuperadmin(true);
        }
        if (user?.acl_settings) {
          setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
        }
      });
  }, []);

  if (loading) {
        return <Loader />
     }

  function onListSuccess(resp) {
    setGroupsData(resp);
  }

  function onError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      console.log(err);
    }
  }

  const filteredGroups = groupsData.filter((group) => {
    const search = searchValue.toLowerCase();

    const matchCommon =
      group.group_name?.toLowerCase().includes(search) ||
      String(group.id)?.toLowerCase().includes(search);

    if (isSuperAdmin) {
      return (
        matchCommon ||
        group.group_creator?.username
          ?.toLowerCase()
          .includes(search)
      );
    }

    return matchCommon;
  });

  const handleCreateGroup = () => {
    const trimmedName = newGroup.name.trim();
    
    if (!trimmedName) {
      setValidationError('Group name cannot be empty');
      return;
    }
    
    setValidationError('');
    setButtonDisable(true);
    
    const groupWithId = {
      group_name: trimmedName,
    };
    
    postApiCall(API_CONTACT_GROUP_CREATE, groupWithId)
      .then((resp) => {
        onCreateSuccess(resp);
        resetForm();
        setButtonDisable(false);
      })
      .catch((err) => {
        onCreateError(err);
        setButtonDisable(false);
      });
  };

  function onCreateSuccess(resp) {
    // setToastProps({
    //   message: "Contact Group created successfully",
    //   type: "success",
    // });
        toast.success("Contact Group created successfully");
    getApiCall(API_CONTACT_GROUP_LIST, {}).then(onListSuccess).catch(onError);
    setShowCreateModal(false);
  }

  function onCreateError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      setButtonDisable(false);
      // setToastProps({ message: JSON.stringify(err), type: "danger" });
          toast.error(JSON.stringify(err));
    }
  }

  const resetForm = () => {
    setNewGroup({
      name: "",
    });
    setValidationError("");
  };

  const handleInputChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    if (!groupNameRegex.test(value)) {
      return;
    }

    setNewGroup((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (validationError) {
      setValidationError("");
    }
  };

  const handleDeleteClick = (rowData) => {
  setSelectedGroup(rowData);
  setShowDeleteModal(true);
};

const confirmDeleteGroup = async () => {
  if (!selectedGroup) return;

  try {
    setDeleteLoading(true);

    const deleteUrl = API_CONTACT_GROUP_DELETE.replace(
      ":id",
      selectedGroup.id
    );

    await postApiCall(deleteUrl, {});

    toast.success("Contact Group deleted successfully");

    // Reload list
    const updatedList = await getApiCall(API_CONTACT_GROUP_LIST, {});
    setGroupsData(updatedList);

    setShowDeleteModal(false);
    setSelectedGroup(null);
  } catch (err) {
    toast.error(err?.message || JSON.stringify(err) || "Error deleting group");
  } finally {
    setDeleteLoading(false);
  }
};

  const handleExport = async () => {
    setButtonDisable(true);
    await exportData("Contact_Groups", setToastProps, setShowToast);
    setButtonDisable(false);
  };

  const handleGroupNameClick = (e, rowData) => {
    e.stopPropagation();  
    navigate(`/contact-group/${rowData.id}`, { state: { group: rowData } });
  };
 
  const groupNameBodyTemplate = (rowData) => {
    return (
      <span
        className="text-primary"
        style={{ cursor: "pointer", textDecoration: "underline" }}
        onClick={(e) => handleGroupNameClick(e, rowData)}
      >
        {rowData.group_name}
      </span>
    );
  };

  const handleRowClick = (rowData) => {
    navigate(`/contact-group/${rowData.id}`, { state: { group: rowData } });
  };

  const groupNameRegex = /^[a-zA-Z0-9]*$/;

  return (
    <div className="contact-groups-container">
      <Row>
        <Col sm="12">
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-0">
              <div className="header-title px-4 py-3">
                <h4 className="card-title m-0">Contact groups</h4>
              </div>

              <div className="px-4 py-3">
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                  <Form
                    className="d-flex align-items-center"
                    style={{ width: "400px" }}
                  >
                    <div className="input-group">
                      <span className="input-group-text">
                        <FiSearch />
                      </span>
                      <Form.Control
                        placeholder={
                          isSuperAdmin
                            ? "Search by group name, group id, created by..."
                            : "Search by group name, group id..."
                          }
                        type="text"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                      />
                    </div>
                  </Form>
                    <div className="d-flex" style={{ gap: "8px" }}>
                  {groupsData.length > 0 && (
                    <Button
                      label="Export Data"
                      icon="pi pi-file-export"
                      onClick={handleExport}
                      className="p-button-active"
                      disabled={buttonDisable}
                    >
                      &nbsp;
                      {buttonDisable && (
                        <span
                          className="spinner-border spinner-border-sm ml-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                      Export
                    </Button>
                  )}
                  {((isSuperAdmin) || (loggedInUserACL?.[MODULE_ACL.CONTACT_GROUP]?.add)) && (
                    <Button
                      variant="primary"
                      className="d-flex align-items-center"
                      onClick={() => setShowCreateModal(true)}
                    >
                      <FiPlus className="me-2" />
                      New Group
                    </Button>
                  )}

                   </div>
                </div>
              </div>

              <div className="pb-4 px-4">
                <div style={{ overflowX: "auto" }}>
                  <DataTable
                    value={filteredGroups}
                    scrollable
                    scrollHeight="flex"
                    tableStyle={{ minWidth: "100%" }}
                    paginator
                    rows={10}
                    rowClassName="p-3"
                  >
                    <Column
                      field="id"
                      header="Group Id"
                      sortable
                      style={{ minWidth: "150px" }}
                    />
                    <Column
                      field="name"
                      header="Group Name"
                      sortable
                      style={{ minWidth: "150px" }}
                      body={groupNameBodyTemplate}
                    />
                    <Column
                      field="member_count"
                      header="Member"
                      sortable
                      style={{ minWidth: "100px" }}
                    />
                    <Column
                      field="group_creator.username"
                      header="Created by"
                      sortable
                      style={{ minWidth: "150px" }}
                    />
                    <Column
                      field="created_at"
                      header="Created At"
                      sortable
                      style={{ minWidth: "200px" }}
                      body={(rowData) =>
                        new Date(rowData.created_at).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                        })
                      }
                    />

                    <Column
                      field="updated_at"
                      header="Updated At"
                      sortable
                      style={{ minWidth: "200px" }}
                      body={(rowData) =>
                        new Date(rowData.created_at).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                        })
                      }
                    />
                    <Column
  header="Action"
  style={{ minWidth: "100px" }}
  body={(rowData) => (
    ((isSuperAdmin) || 
     (loggedInUserACL?.[MODULE_ACL.CONTACT_GROUP]?.delete)) && (
      <FiTrash2
        style={{ cursor: "pointer", color: "red" }}
        onClick={() => handleDeleteClick(rowData)}
      />
    )
  )}
/>
                  </DataTable>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Create Group Modal */}
      <Modal
        show={showCreateModal}
        onHide={() => {
          setShowCreateModal(false);
          resetForm();
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>New Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Group Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newGroup.name}
                onChange={handleInputChange}
                placeholder="Enter group name"
                required
                isInvalid={!!validationError}
              />
              <Form.Control.Feedback type="invalid">
                {validationError}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowCreateModal(false);
              resetForm();
            }}
          >
            Discard Changes
          </Button>
          <Button 
            variant="primary" 
            onClick={handleCreateGroup}
            disabled={buttonDisable}
          >
            {buttonDisable ? (
              <span className="spinner-border spinner-border-sm" role="status"></span>
            ) :  'Create Group'}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
      <Modal
  show={showDeleteModal}
  onHide={() => {
    setShowDeleteModal(false);
    setSelectedGroup(null);
  }}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Delete Group</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    Are you sure you want to delete this group?
  </Modal.Body>
  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => {
        setShowDeleteModal(false);
        setSelectedGroup(null);
      }}
    >
      Cancel
    </Button>
    <Button
      variant="danger"
      onClick={confirmDeleteGroup}
      disabled={deleteLoading}
    >
      {deleteLoading ? (
        <span className="spinner-border spinner-border-sm" />
      ) : (
        "Delete"
      )}
    </Button>
  </Modal.Footer>
</Modal>
    </div>
  );
};

export default ContactGroupList;